import React, { PureComponent } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { get as _get } from 'lodash';

export const AbilityMap = [
  { id: 1, l: 'Driver', c: '#000000', a: 'DR' },
  { id: 2, l: 'Team Leader', c: '#DC873F', a: 'TL' },
  { id: 4, l: 'Canvasser', c: '#66dfa6', a: 'CORE' },
  { id: 4, l: 'Day 1', c: '#cc63b1', a: 'D1' },
  { id: 5, l: 'Day 2', c: '#a5acf9', a: 'D2' },
  { id: 6, l: 'Day 3', c: '#4e5beb', a: 'D3' },
  { id: -1, l: 'Other', c: '#383838', a: 'Other' },
];

export const AvailRoleToken = ({ role }) => {
  let abb, color;
  if (role === 'Driver') {
    abb = 'DR';
    color = '#000000';
  } else if (role === 'Team Leader') {
    abb = 'TL';
    color = '#DC873F';
  } else if (role === 'Day 1') {
    abb = 'D1';
    color = '#cc63b1';
  } else if (role === 'Day 2') {
    abb = 'D2';
    color = '#a5acf9';
  } else if (role === 'Day 3') {
    abb = 'D3';
    color = '#4e5beb';
  } else if (role === 'Canvasser') {
    abb = 'CORE';
    color = '#66dfa6';
  } else {
    abb = 'Other';
    color = 'rgb(176, 176, 176)';
  }

  if (!abb) return null;

  return (
    <span className={'availRoleToken'} style={{ color, borderColor: color }}>
      {abb}
    </span>
  );
};

class DraggableShiftCanvasser extends PureComponent {
  constructor(props) {
    super(props);
  }

  _renderCanvasser(provided, snapshot) {
    const canvasser = this.props.canvasser;

    return (
      <div
        className={`schedule-canvasser-card`}
        ref={provided.innerRef}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
      >
        <div
          className="available-route"
          style={{
            borderLeftColor: this.props.color,
            color: this.props.color,
            width: '100%',
          }}
          id={this.props.id}
        >
          {/* NAME + ALL ATTRIBUTES IN ONE WRAPPING ROW */}
          <div
            className="obj-title small-font"
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              gap: '6px',
            }}
          >
            {/* NAME FIRST */}
            <span>
              {canvasser.firstname} {canvasser.lastname}{' '}
              <span className={'slashline'}>{canvasser.metrics}</span>
            </span>

            {/* ATTRIBUTES WRAP AS A UNIT */}
            <span
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '0px',
                alignItems: 'left',
              }}
            >
              {_get(canvasser, 'is_training', false) && (
                <span className={'assignedToken danger'}>TRAINING USER</span>
              )}

              {this.props.assigned && <span className={'assignedToken'}>Assigned</span>}

              {_get(canvasser, 'abilities', []).map((d) => (
                <AvailRoleToken role={(d || {}).name} key={d.id} />
              ))}
            </span>
          </div>

          {/* NOTE: Removing the old two-row obj-data blocks completely */}
        </div>
      </div>
    );
  }

  render() {
    let draggableId = this.props.draggableId;
    return (
      <Draggable
        draggableId={draggableId}
        index={this.props.index}
        key={this.props.draggableId + this.props.index}
        type={this.props.dragType || "DEFAULT"}
      >
        {(provided, snapshot) => <>{this._renderCanvasser(provided, snapshot)}</>}
      </Draggable>
    );
  }
}

export default DraggableShiftCanvasser;
